import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Row, Col, message, List, Table, Tooltip } from 'antd';
import injectSheet from 'react-jss';
import { fetchBidRevisionHistory } from 'src/api/inquiry';
import { getSuperScriptTextForNumber } from 'src/utils/utils';
import Loader from 'src/components/common/Loader';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import classNames from 'classnames';
import { isValidArray, getDateValue } from 'src/Library/Helper';
import { InquiryModes } from 'src/Library/Constants';
import _ from 'lodash';
import { BID_ROUTES } from './InquiryUtils';
import { tokens } from 'src/design-system';

const styles = theme => ({
  modal: {
    '& .ant-modal-body': {
      paddingBottom: 5,
    },
  },
  okButton: {
    backgroundColor: tokens.colors.primary,
    color: tokens.colors.bgWhite,
    border: 0,
    '&:hover': {
      backgroundColor: tokens.colors.primary,
      color: tokens.colors.bgWhite,
    },
  },
  inquiryInfo: {
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
    marginTop: '5px',
  },
  overflowCell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
  },
  columns: {
    fontSize: `${tokens.fontSize.small}px`,
  },
  columnBorder: {
    border: '1px solid #E4E4E4',
    borderRight: 'none',
  },
  diffTableColumn: {
    borderBottom: '1px solid #E4E4E4',
    borderTop: '1px solid #E4E4E4',
  },
  prevBidText: {
    color: '#262626',
    fontSize: `${tokens.fontSize.body}px`,
    letterSpacing: '0',
    lineHeight: '14px',
    marginBottom: '5px',
  },
  prevBidTime: {
    width: '100%',
    color: '#777777',
    fontSize: `${tokens.fontSize.caption}px`,
    fontStyle: 'italic',
    letterSpacing: '0',
    marginBottom: '0',
  },
  revBidText: {
    display: 'inline-block',
    color: '#262626',
    fontSize: `${tokens.fontSize.body}px`,
    letterSpacing: '0',
    lineHeight: '14px',
  },
  tableStyle: {
    marginTop: '20px',
    marginBottom: '20px',
    border: '1px solid #E4E4E4',
    borderTop: 'none',
    '& .ant-table-thead > tr:first-child > th:first-child': {
      borderTopLeftRadius: 0,
      height: '60px',
    },
    '& .ant-table-thead > tr:first-child > th:last-child': {
      borderTopRightRadius: 0,
    },
    '& .ant-table-thead > tr > th': {
      padding: '12px 12px 8px 12px !important',
    },
  },
});
class BidRevisionModal extends React.PureComponent<any, any> {
  state = {
    loading: true,
    bids: undefined,
    generalDetailsKeys: [],
    originCharges: [],
    destinationCharges: [],
    freightCharges: [],
    freeDaysKeys: [],
  };

  async componentDidMount() {
    const { baseRevisionBidId, userType } = this.props;
    const keysToHide = [
      'freightChargeId',
      'originChargeId',
      'destinationChargeId',
      'criteriaId',
      'criteriaRuleId',
    ];
    if (baseRevisionBidId) {
      const response = await fetchBidRevisionHistory(baseRevisionBidId, userType);
      const bids = response.data;
      isValidArray(bids) ? keysToHide.forEach(key => delete bids[bids.length - 1]?.otherDetails[key]) : []
      if (response.isSuccess) {
        this.setState({
          bids: isValidArray(response.data) ? bids : [],
          loading: false,
        });
      } else {
        message.error(response.errorMessage);
        this.setState({ loading: false });
      }
    } else {
      this.setState({ loading: false });
    }
  }

  getBidsData = () => {
    const { baseRevisionBidId, bidsData } = this.props;
    const { bids } = this.state;
    return baseRevisionBidId ? bids : bidsData;
  }

  renderDot = (style) => {
    return <span style={{
      marginBottom: '3px', height: '10px', width: '10px',
      borderRadius: '10px', display: 'inline-block',
      verticalAlign: 'middle', marginRight: '8px',
      ...style,
    }} />;
  }

  renderLine = () => {
    return <div style={{ borderLeft: '2px solid #656565', height: '15px',
      margin: '-5px 4px' }}>
    </div>;
  }

  renderInquiryDetails = () => {
    const { classes, inquiryDetails, globalShippingLines, globalCarriers } = this.props;
    const bids = this.getBidsData();
    let carrier = '';
    let carrierData: any = {};
    if (bids && bids[0]) {
      carrier = bids[0].ffCarrier;
      carrierData = [...globalShippingLines, ...globalCarriers].find(sl =>
        sl.id === carrier) || {};
    }
    if (!inquiryDetails) {
      return null;
    }
    return <Row style={{ marginBottom: '10px' }}>
      <Col span={9}>
        <div style={{ fontWeight: 'bold' }}>{inquiryDetails.referenceNumber}
        &nbsp;&nbsp;|&nbsp;&nbsp;
        {inquiryDetails.mode}
        </div>
        { inquiryDetails.shipperName &&
          <div className={classes.inquiryInfo}>
            {inquiryDetails.shipperName}
          </div>
        }
      </Col>
      <Col span={8}>
        {inquiryDetails.origin?.port && inquiryDetails.destination?.port &&
        <React.Fragment>
          <div style={{ fontSize: `${tokens.fontSize.small}px` }}>{this.renderDot({ backgroundColor: '#656565' })}
            {inquiryDetails.origin?.port} (Origin)</div>
          {this.renderLine()}
          <div style={{ fontSize: `${tokens.fontSize.small}px`, marginTop: '2px' }}>{this.renderDot({ border: '1px solid #656565' })}
            {inquiryDetails.destination?.port} (Destination)</div>
        </React.Fragment>}
      </Col>
      <Col span={7}>
      { inquiryDetails.carrierLogoUrl ? <div style={{ paddingBottom: '5px' }}><div style={{
        height: '25px', width: '100px',
        backgroundImage: `url("${inquiryDetails.carrierLogoUrl}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center' }}></div></div> :
        <div style={{ paddingBottom: '7px' }}>
          {
            carrierData.logoUrl ?
            <Tooltip title={carrierData.name} placement="topLeft">
              <img src={carrierData.logoUrl} style={{ width: 'auto' }} />
            </Tooltip> : (carrierData.name || carrier)
          }
        </div>}
      </Col>
    </Row>;
  }

  displayTotalPrice = () => {
    const { newBidTotal, userType, defaultCurrency, exchangeRates } = this.props;
    const bids = this.getBidsData();
    const originalBid = bids[0];
    const bidTotal = userType === 'SHIPPER' ? originalBid.shipperTotal : originalBid.ffTotal;
    if (bidTotal.currency !== defaultCurrency && !exchangeRates[bidTotal.currency]) {
      return null;
    }
    const bidTotalAmountOriginal = bidTotal.currency !== defaultCurrency ?
      (bidTotal.amount * exchangeRates[bidTotal.currency]) : bidTotal.amount;
    const priceDiff = +(newBidTotal - bidTotalAmountOriginal).toFixed(2);
    if (priceDiff === 0) {
      return <div style={{ fontStyle: 'italic', marginBottom: '10px' }}>
      The total charges are
      <span style={{ fontWeight: tokens.fontWeight.semibold, fontStyle: 'normal' }}>
        &nbsp;same</span>
      </div>;
    }
    return <div style={{ fontStyle: 'italic', marginBottom: '10px' }}>
      Total Price of the Revised Bid is
      <span style={{ fontWeight: tokens.fontWeight.semibold, fontStyle: 'normal' }}>
        &nbsp;{this.getAmountString({
          amount: Math.abs(priceDiff),
          currency: defaultCurrency,
        })}</span> {priceDiff > 0 ? 'more' : 'less'} than the previous bid</div>;
  }

  getAmountString = (data: { amount: number, currency: string }): string => {
    return `${data.amount.toFixed(2)} ${data.currency}`;
  }

  getChargeDataObject = (key, chargeDetails): { name: string, total: number }[] => {
    const { userType } = this.props;
    if (chargeDetails && chargeDetails[key] && chargeDetails[key].values &&
      chargeDetails[key].values.length) {
      return chargeDetails[key].values.map(val => ({
        name: val.name,
        total: `${
          this.getAmountString({
            amount: userType === 'SHIPPER' ? (val?.userPrice?.amount || val.price) : val.price,
            currency: userType === 'SHIPPER' ? (val?.userPrice?.currency || val.currency) : val.currency,
          })
        }${val.unitType ? ` / ${val.unitType.replace('Per ', '')}` : ''}${val.unitCount ?
          ` * ${val.unitCount.toFixed(2)}` : ''}${val.tax ? ` (${val.tax})` : ''}`,
      }));
    }
    return [];
  }

  prepareMapByName = (nameTotalData: { [key: string]: { name: string, total: number }[] },
    index: number, map) => {
    const length: number = this.getBidsData().length;
    const chargeNameMap = {
      freightData: 'Freight',
      originData: 'Origin',
      destinationData: 'Destination',
    };
    Object.keys(nameTotalData).forEach((chargeKey) => {
      nameTotalData[chargeKey].forEach(({ name, total }) => {
        const keyName =
          `${(this.props.inquiryDetails.mode === InquiryModes.TRAILER) ? '' :
          `${chargeNameMap[chargeKey]} - `}${name}`;
        if (!map[keyName]) {
          map[keyName] = Array(length + 1).fill('-');
          map[keyName][0] = keyName;
        }
        map[keyName][index + 1] = total || '-';
      });
    });
  }

  calculateDiff = () => {
    const bids = this.getBidsData();
    const dataMapCharges: any = {};
    const dataMapOtherDetails: any = {};
    const otherDetailKeysPrettyNameMap = {
      demurrageFreeDays: 'Demurrage Free Days',
      detentionFreeDays: 'Detention Free Days',
      originFreeDays: 'Origin Free Days',
      cfsFreeDays: 'CFS Free Days',
      remarks: 'Remarks',
      schedule: 'Schedule',
      etd: 'ETD',
      transshipmentVia: 'Transshipment Via',
      transitTime: 'Transit Days',
      originFreeTime: 'Origin Free Days',
      cfsFreeTime: 'CFS Free days',
      demurrageFreeTime: 'Demurrage Free Days',
      detentionFreeTime: 'Detention Free Days',
      roundTripTime: 'Round Trip Time',
      detentionCostPerDay: 'Detention Cost Per Day',
      termsAndConditions: 'Terms And Conditions',
      route: 'Route',
      combinedFreeTime: 'Combined Free Days',
    };

    if (bids && bids.length) {
      bids.forEach((bid, bidIndex) => {
        const { chargeDetails, otherDetails } = bid;

        const freightData = this.getChargeDataObject('freightCharges', chargeDetails);
        const originData = this.getChargeDataObject('originCharges', chargeDetails);
        const destinationData = this.getChargeDataObject('destinationCharges', chargeDetails);
        this.prepareMapByName({
          freightData,
          originData,
          destinationData,
        }, bidIndex, dataMapCharges);

        Object.keys(otherDetails).forEach((otherDetailsKeyRaw: string) => {
          const otherDetailsKey = otherDetailKeysPrettyNameMap[otherDetailsKeyRaw]
          || otherDetailsKeyRaw;
          if (!dataMapOtherDetails[otherDetailsKey]) {
            dataMapOtherDetails[otherDetailsKey] = Array(bids.length + 1).fill('-');
            dataMapOtherDetails[otherDetailsKey][0] = otherDetailsKey;
          }
          let dataToFill;
          const { currency } = this.props;
          switch (otherDetailsKeyRaw) {
            case 'schedule':
              dataToFill = (otherDetails[otherDetailsKeyRaw] &&
              otherDetails[otherDetailsKeyRaw].length) ?
              otherDetails[otherDetailsKeyRaw].join(', ') : '-';
              break;
            case 'route':
              dataToFill = otherDetails[otherDetailsKeyRaw]?.map(e => BID_ROUTES[e] || e).join(', ') || '-';
              break;
            case 'transshipmentVia':
              dataToFill = (otherDetails[otherDetailsKeyRaw] &&
                otherDetails[otherDetailsKeyRaw].length) ?
                otherDetails[otherDetailsKeyRaw].map(e => e.label).join(', ') : '-';
              break;
            case 'roundTripTime':
              dataToFill = (otherDetails[otherDetailsKeyRaw] &&
                `${otherDetails[otherDetailsKeyRaw]?.value} ${otherDetails[otherDetailsKeyRaw]?.type}`);
              break;
            case 'detentionCostPerDay':
              dataToFill = (otherDetails[otherDetailsKeyRaw] &&
                `${currency[otherDetails[otherDetailsKeyRaw]?.currency]}${otherDetails[otherDetailsKeyRaw]?.amount}`);
              break;
            case 'etd':
            case 'eta':
            case 'siCutOff':
              dataToFill = getDateValue(otherDetails[otherDetailsKeyRaw]?.dateString)?.format('DD MMM YYYY') ||
                getDateValue(otherDetails[otherDetailsKeyRaw])?.format('DD MMM YYYY') || '-';
              break;
            case 'termsAndConditions':
              dataToFill = !_.isNil(otherDetails[otherDetailsKeyRaw]) ? otherDetails[otherDetailsKeyRaw].name : '';
              break;
            default:
              const value = otherDetails[otherDetailsKeyRaw];
              dataToFill = typeof value === 'object'
                ? getDateValue(value?.dateString)?.format('DD MMM YYYY') ||
                  getDateValue(value)?.format('DD MMM YYYY') || '-'
                : value || '-';
          }
          dataMapOtherDetails[otherDetailsKey][bidIndex + 1] = dataToFill;
        });

        const { timezone } = this.props;
        if (!dataMapOtherDetails['Valid Till']) {
          dataMapOtherDetails['Valid Till'] = Array(bids.length + 1).fill('-');
          dataMapOtherDetails['Valid Till'][0] = 'Valid Till';
        }
        dataMapOtherDetails['Valid Till'][bidIndex + 1] = bid.validTill ?
        momentTimezone(bid.validTill).tz(timezone).format('DD/MM/YYYY hh:mm A') : '-';
      });
    }
    return {
      dataMapCharges,
      dataMapOtherDetails,
    };
  }

  checkDataMapsForDuplicates = (map): void => {
    Object.keys(map).forEach((key) => {
      const arr = map[key].slice(1);
      let isSame = true;
      for (let i = 1; i < arr.length; i += 1) {
        if (arr[i] !== arr[0]) {
          isSame = false;
          break;
        }
      }

      if (isSame) {
        delete map[key];
      }
    });
  }

  renderRevisedBidTableHeader = (bid) => {
    const { classes } = this.props;
    return <div>
      <p className={ classes.prevBidText }>Previous Bid</p>
      { this.renderBidTableHeaderTime(bid) }
    </div>;
  }

  renderRevisedHistoryBidTableHeader = (bid) => {
    const { classes } = this.props;
    return (bid.revisionNumber > 0
      ?
        <div>
        <p className={ classes.prevBidText }>
          {bid.revisionNumber}{getSuperScriptTextForNumber(bid.revisionNumber)} Revision
        </p>
        { this.renderBidTableHeaderTime(bid) }
        </div>
      : <span className={ classes.revBidText }>Base Version</span>);
  }

  renderBidTableHeaderTime = (bid) => {
    const { classes } = this.props;
    const updatedDaysAgo = bid && moment().diff(bid.updatedAt, 'days');
    return <p className={ classes.prevBidTime }>
      { updatedDaysAgo ? `${updatedDaysAgo} days ago | ` : '' }{
        moment(bid.updatedAt).format('h:mm')
      } hrs
    </p>;
  }

  renderDiffTable = () => {
    const { classes, userType, isEdit, defaultCurrency, newBidTotal } = this.props;

    const columns: any[] = [{
      title: <span className={ classes.revBidText }>Bid Details</span>,
      width: 300,
      dataIndex: '0',
      key: '0',
      fixed: true,
      className: classNames(classes.columns, classes.diffTableColumn),
      render: value => <div className={classes.overflowCell} style={{ color: '#262626', maxWidth: '300px'}}>
        <Tooltip title={value}>
          {value}
        </Tooltip>
      </div>,
    }];

    const bids = this.getBidsData();
    const totalChargesRow = ['Total Charges'];
    bids.forEach((bid, index) => {
      columns.push({
        title: isEdit ?
        (index === 0
          ? this.renderRevisedBidTableHeader(bid)
          : <span className={ classes.revBidText }>Revised Bid</span>)
        : this.renderRevisedHistoryBidTableHeader(bid),
        dataIndex: `${index + 1}`,
        key: `${index + 1}`,
        width: 170,
        className: classNames(classes.columns, classes.columnBorder),
        render: value => <div className={classes.overflowCell} style={{maxWidth: '170px'}}>
          {
            <Tooltip title={ value && ((typeof value === 'string') ? value.split('*')[0] : value) }>
              { value && ((typeof value === 'string') ? value.split('*')[0] : value) }
            </Tooltip>
          }
        </div>,
      });

      if (!isEdit || index === 0) {
        totalChargesRow.push(
          this.getAmountString(userType === 'SHIPPER' ? (bid?.userTotal || bid.shipperTotal) : bid.ffTotal));
      } else {
        totalChargesRow.push(this.getAmountString({
          amount: newBidTotal,
          currency: defaultCurrency,
        }));
      }
    });

    const { dataMapCharges, dataMapOtherDetails } = this.calculateDiff();

    this.checkDataMapsForDuplicates(dataMapCharges);
    this.checkDataMapsForDuplicates(dataMapOtherDetails);

    const aoaData = Object.keys(dataMapCharges).map(key => dataMapCharges[key]);
    aoaData.push(...Object.keys(dataMapOtherDetails).map(key => dataMapOtherDetails[key]));
    aoaData.push(totalChargesRow);
    return <Table
      bordered={false}
      className={classes.tableStyle}
      pagination={false}
      dataSource={aoaData}
      columns={columns}
      rowKey={record => record[0]}
      scroll={{ x: (bids.length * 170) + 400 }}
      />;
  }

  render() {
    const { visible, classes, cancelVisible, handleCancel, title, okText, cancelText,
      handleOk, isEdit } = this.props;
    const { loading } = this.state;
    return <Modal
      className={classes.modal}
      closable={true}
      onCancel={handleCancel}
      width={800}
      visible={visible}
      footer={[
        <div key="footer">{cancelVisible && <Button key="cancel" size="large"
          onClick={handleCancel}>
          {cancelText || 'Cancel'}
        </Button>}
        <Button key="submit" size="large" className={classes.okButton}
          onClick={handleOk}>
          {okText}
        </Button></div>,
      ]}
      title={title}>
        {this.renderInquiryDetails()}
        {
          loading ? <div style={{ height: '200px' }}>
            <Loader/>
          </div> : <div>
            {this.renderDiffTable()}
            {isEdit && this.displayTotalPrice()}
          </div>
        }
    </Modal>;
  }
}

const mapStateToProps = ({ masterData, inquiryFFBidsReducer }) => ({
  currency: masterData.currencySymbols,
  globalShippingLines: masterData.globalShippingLines,
  globalCarriers: masterData.globalCarriers,
  exchangeRates: inquiryFFBidsReducer.chargeDetails.exchangeRates,
  timezone: masterData.timezone,
});

export default injectSheet(styles)(connect(mapStateToProps, null)(BidRevisionModal));
